"use strict";

import * as React from 'react';
import { deepFreeze } from "./deepFreeze.js";
const createStore = getInitialState => {
  const listeners = [];
  let initialized = false;
  let state;
  const getState = () => {
    if (initialized) {
      return state;
    }
    initialized = true;
    state = deepFreeze(getInitialState());
    return state;
  };
  const setState = newState => {
    state = deepFreeze(newState);
    listeners.forEach(listener => listener());
  };
  const subscribe = callback => {
    listeners.push(callback);
    return () => {
      const index = listeners.indexOf(callback);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  };
  return {
    getState,
    setState,
    subscribe
  };
};
export function useSyncState(getInitialState) {
  const store = React.useRef(createStore(getInitialState)).current;
  const state = React.useSyncExternalStore(store.subscribe, store.getState, store.getState);
  React.useDebugValue(state);
  return [state, store.getState, store.setState];
}
//# sourceMappingURL=useSyncState.js.map